import { Button } from '@deere/ux.uxframe-react'
import { saveAs } from 'file-saver'
import React from 'react'
import ExcelJS from "exceljs/dist/exceljs.min"

export const Template = ({csvData, fileName}) => {

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = async (csvData, fileName) => {
        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('data')
        if (csvData.length > 0) {
            worksheet.addRow(Object.keys(csvData[0]))
            csvData.forEach(row => worksheet.addRow(Object.values(row)))
        }
        const excelBuffer = await workbook.xlsx.writeBuffer()
        const data = new Blob([excelBuffer], {type: fileType})
        saveAs(data, fileName + fileExtension)
    }

    const handleClick = async event => {
        await exportToCSV(csvData, fileName)
    }

    return (
        <Button onClick={handleClick}>Download</Button>
    )
}